<template>
  <div class="p-grip p-fluid" >
      <DataTable :value="autorizacoes.content" :selection.sync="autorizacoesSelecionada" dataKey="key">
        <Column selectionMode="multiple" headerStyle="width: 3em" ></Column>        
        <Column field="data.nomeExibir" header="Name" ></Column>
        <Column field="data.descricaoAutorizacao" header="Descrição"></Column>
        <Column field="nomeRole" header="Nome Role"></Column>

      </DataTable>
  </div>
</template>


<script>
import { baseApiUrl } from '@/config/global'

export default {
  components: { },
  props:{
    parmAutorizacaoSelecionada:{
      type:Array,
      required:true
    },
  },
  data:function(){
    return{
      autorizacoes: [],
      selecionada : [],
      camposTabelaBens:[
        {nome:'data.nomeExibir', titulo: 'Name'},
        {nome:'data.descricaoAutorizacao', titulo: 'Descrição'},
      ]
    }
  },
  methods:{
    async carregarDados(){
      this.$http.get(`${baseApiUrl}/seguranca/autorizacaos/buscaPorSistema`).then(res=>{
        this.autorizacoes = res.data
      })
      this.selecionada = this.parmAutorizacaoSelecionada
    }
  },
  mounted(){
    this.carregarDados()
  },
  computed:{
    autorizacoesSelecionada:{
      get(){
        return this.selecionada
      },
      set(value){
        this.selecionada = value
        this.$emit('update:autorizacoeSelecionada',value)
      }
    }
    
  }
}
</script>